import React from 'react';
import { saveAs } from 'file-saver'
import { pdf } from '@react-pdf/renderer'
import { Page, Canvas, Svg, PDFViewer, PDFDownloadLink, Text, View, Document, StyleSheet, Image, Font, } from '@react-pdf/renderer';
import { FaCertificate } from 'react-icons/fa';



interface ICreateModule {
    lineData: Record<string, any>;

}

export default function UpdateModule({

    lineData,

}: ICreateModule): JSX.Element {


    const replaceData = (certificate, text) => {

        if (!text) {
            return '';
        }

        const { name = '', data = {} } = certificate?.user_id_response;

        data.name = name;

        Object.keys(data).map(key => {
            text = text.replace(`{${key}}`, data[key]);
        })

        return text;



    }

    const downloadCertificate = ({ certificate }) => {
        const handleDownload = async () => {




            const styles = StyleSheet.create({
                page: {
                    position: 'relative',
                    width: '27.9cm',
                    margin: '0px',
                    height: certificate?.certificate_id_response?.height || '21cm',
                    backgroundColor: "#fff",
                    color: "#333",


                },

            });


            const item: any = document.getElementById(`canvas-cert-${certificate.hash}`);

            console.log(`canvas-cert-${certificate.hash}`, item);




            const DocumentElements: React.FC = () => <><Document  >
                {/*render a single page*/}
                <Page orientation="landscape" wrap={false} style={styles.page}>

                    <View style={{ width: "100%", zIndex: 0, position: 'absolute', top: 0, left: 0, opacity: 1 }}  >  <Image src={`http://avc.encontrodigital.com.br.s3-website-us-east-1.amazonaws.com/${certificate?.certificate_id_response?.image}`} style={{
                        minWidth: '100%',
                        minHeight: '100%',
                        display: 'flex',
                        height: '100%',
                        width: '100%',
                    }} />
                    </View>

                    {certificate?.certificate_id_response?.content?.map(text => {

                        const style: Record<string, any> = {
                            fontSize: text.size,
                            fontFamily: text.fontWeight === 'bold' || text.fontWeight === '800' ? 'Helvetica-Bold' : 'Helvetica',
                            left: text.left,
                            top: text.top,
                            position: 'absolute',

                            width: text.width === '95%' ? '100%' : text.width,
                            textAlign: text.align,
                            color: text.color || '#000',


                        }


                        if (text?.element === 'h2') {
                            style.textTransform = 'uppercase';
                        }

                        if (text.text.indexOf('<strong') >= 0) {
                            text.text = text.text.replace('<strong>', '').replace('</strong>', '');
                            style.fontFamily = 'Helvetica-Bold';
                        }

                        text.text = replaceData(certificate, text.text);



                        return <View><Text fixed style={style}  > {text.text}  </Text></View>
                    })}



                    <View style={{ width: "70px", backgroundColor: '#fff', height: '90px', alignSelf: 'flex-end', marginTop: '-90px', display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', position: 'absolute', top: certificate?.certificate_id_response?.height || '21cm', right: '10px' }}  >
                        <Image style={{ width: '50px', height: '50px' }} src={item.toDataURL()} /><Text style={{ fontSize: '8px', color: '#000', textAlign: 'center', marginTop: '5px' }}   >Leia para validar</Text></View>
                </Page>
            </Document ></>;


            const blob = await pdf(<DocumentElements />).toBlob()
            saveAs(blob, 'certificado.pdf')
        }



        handleDownload()


    }

    const moduleUpdate = (idUser: string): JSX.Element => (
        <button className="lineIcon" title="Editar" type="button" onClick={() => downloadCertificate({ certificate: lineData })}>
            <FaCertificate />
        </button>
    );

    return moduleUpdate(lineData.id);
}
